export const iconFontAwesomeDesignIcons = (
	<i className="fa-solid fa-icons"></i>
);
